export default __webpack_public_path__ + "static/media/oluseun.49f9afaf.jpg";